import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodosItens() {
        let url = `${api}/baseconhecimento/itens/todos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItensAtivos() {
        let url = `${api}/baseconhecimento/itens`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposItens() {
        let url = `${api}/baseconhecimento/tipositens`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItemLocal(item) {
        const formData = new FormData()
        formData.append('tipoItemId', item.tipoItemId)
        formData.append('nome', item.nome)
        formData.append('descricao', item.descricao)
        formData.append('arquivo', item.arquivo)
        formData.append('nivelAcesso', item.nivelAcesso)
        let url = `${api}/baseconhecimento/item/local`
        return axiosJwt
            .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItemRemoto(item) {
        let url = `${api}/baseconhecimento/item/remoto`
        return axiosJwt
            .post(url, item)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemLocal(item) {
        const formData = new FormData()
        formData.append('itemId', item.itemId)
        formData.append('tipoItemId', item.tipoItemId)
        formData.append('nome', item.nome)
        formData.append('descricao', item.descricao)
        formData.append('arquivo', item.arquivo)
        formData.append('nivelAcesso', item.nivelAcesso)
        let url = `${api}/baseconhecimento/item/local/atualizar`
        return axiosJwt
            .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemRemoto(item) {
        let url = `${api}/baseconhecimento/item/remoto/atualizar`
        return axiosJwt
            .post(url, item)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadItemLocal(itemId) {
        return axiosJwt
            .get(`${api}/baseconhecimento/item/local/${itemId}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarDesativarItem(itemId) {
        let url = `${api}/baseconhecimento/item/${itemId}/ativardesativar`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirItem(itemId) {
        let url = `${api}/baseconhecimento/item/${itemId}`
        return axiosJwt
            .delete(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
